import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { selectIsRoleHASupport } from "../../../domain/Account/userSlice"
import { appRoutes } from "../../../routes"

/**
 * Restricts access to HA Support pages. If the current user does not have the HA Support role,
 * they are redirected to the help page.
 */
export const WithHASupportAuthentication: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const isHASupport = useSelector(selectIsRoleHASupport)

  if (!isHASupport) {
    return <Navigate to={appRoutes.HELP_ROUTE} replace />
  }

  return <>{children}</>
}

export default WithHASupportAuthentication
